import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AdminRating } from 'app/shared/models/class/rating/admin-rating';
import { Rating } from 'app/shared/models/class/rating/rating';
import { environment } from 'environments/environment';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RatingService {

  ratingSubject = new Subject<number>();

  constructor(private http: HttpClient) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getRating(): Observable<Rating[]> {
    return this.http.get<Rating[]>(`${environment.apiUrl}Rating/admin`)
  }

  vote(votes: AdminRating[]): Observable<any> {
    return this.http.post(`${environment.apiUrl}Rating/admin`, votes);
  }

}
